import * as React from "react";
import { Redirect, Route } from "react-router-dom";

type Props = {
  component: React.ComponentType<any>;
  isAuthenticated: boolean;
  path: string;
};

export const PrivateRoute: React.FC<Props> = ({
  component: Component,
  isAuthenticated,
  ...otherProps
}) => {
  return (
    <Route
      {...otherProps}
      render={(props) =>
        isAuthenticated ? (
          <Component {...props} {...otherProps} />
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};
